import * as smoothscroll from 'smoothscroll-polyfill';
var gumshoe = require('../vendor/gumshoe');

let heroBlocksPosition = [];
let resizeTimer = null;
let heroBlocks = Array.prototype.slice.call(document.querySelectorAll(".hero-block"));
let homeBlockNavLink = null;
let titles = Array.prototype.slice.call(document.querySelectorAll(".hero-title"));
let titlesInnerHTML = [];

// For IE and Edge
smoothscroll.polyfill();

window.addEventListener("DOMContentLoaded", function () {
    titles.forEach(function (title) {
        titlesInnerHTML.push(title.innerHTML);
    })

    truncateLongTitles();

    if (document.querySelector(".scrollspy-dot-navbar")) {
        let navbarContainer = document.querySelectorAll('.scrollspy-dot-navbar')[0];

        // Find all sections to add to scrollspy nav list
        const jumpSections = Array.prototype.slice.call(document.querySelectorAll('[data-scrollspy="true"]'));
        let jumpList = '';

        // Create list item by looping through each section
        jumpSections.forEach(section => {
            let sectionTarget = section.id;

            jumpList += `<li><a data-scroll-ignore href="#${sectionTarget}"></a></li>`;
        });

        // Add string of list items to scrollspy nav
        const jumpListContainer = navbarContainer.querySelectorAll('nav ul')[0];
        jumpListContainer.innerHTML = jumpList;

        // Handler when the DOM is fully loaded
        initGumshoe()
    };

    heroBlocks.forEach(function (block) {
        let blockPosition = block.offsetTop - block.scrollTop + block.clientTop;
        heroBlocksPosition.push(blockPosition);
    })

    let homeBlockNav = Array.prototype.slice.call(document.querySelector(".home-page-nav").querySelectorAll("li"));

    for (let i = 0; i < homeBlockNav.length; i++) {
        homeBlockNav[i].querySelector("a").addEventListener("click", function (e) {
            e.preventDefault();
            window.scrollTo({ top: heroBlocksPosition[i], left: 0, behavior: 'smooth' });
        })
    }
})

window.addEventListener("resize", function () {  
    if (resizeTimer != null) {
        clearTimeout(resizeTimer);
    }

    resizeTimer = setTimeout(function () {
        heroBlocksPosition = [];

        heroBlocks.forEach(function (block) {
            let blockPosition = block.offsetTop - block.scrollTop + block.clientTop;
            heroBlocksPosition.push(blockPosition);
        })

        initGumshoe()
    }, 500);

    truncateLongTitles();
})

function addActiveClass() {
    let activeHeroBlockId = document.querySelector("a.home-page-nav-active").getAttribute("href");
    let activeHeroBlock = document.querySelector(activeHeroBlockId);
    let heroTintOverlay = activeHeroBlock.querySelector(".hero-tint-overlay");
    let heroContent = activeHeroBlock.querySelector(".hero-content");

    if (!heroTintOverlay.classList.contains("hero-tint-overlay-show")) {
        heroTintOverlay.classList.add("hero-tint-overlay-show");
    }

    if (!heroContent.classList.contains("hero-content-show")) {
        heroContent.classList.add("hero-content-show");
    }
}

function truncateLongTitles() {
    for (let i = 0; i < titles.length; i++) {       
        titles[i].innerHTML = titlesInnerHTML[i];

        if (window.innerWidth <= 1600 && window.innerWidth > 1280) {
            // Upperbound is equal to 2 times the title font-size at this breakpoint
            // This prevents the title from ever wrapping over 2 lines
            if (titles[i].clientHeight > 432) {
                titles[i].innerHTML = titles[i].innerHTML.substring(0, 18) + "...";
            }
            else {
                titles[i].innerHTML = titlesInnerHTML[i];
            }
        }
        if (window.innerWidth <= 1280 && window.innerWidth > 1025) {
            if (titles[i].clientHeight > 320) {
                titles[i].innerHTML = titles[i].innerHTML.substring(0, 18) + "...";
            }
            else {
                titles[i].innerHTML = titlesInnerHTML[i];
            }
        }
        if (window.innerWidth <= 1025) {
            if (titles[i].clientHeight > 240) {
                titles[i].innerHTML = titles[i].innerHTML.substring(0, 18) + "...";
            }
            else {
                titles[i].innerHTML = titlesInnerHTML[i];
            }
        }
    }
}

function initGumshoe() {
    gumshoe.init({
        selector: '[data-gumshoe] a', // Default link selector (must use a valid CSS selector)
        //selectorHeader: '#siteHeader', // Fixed header selector (must use a valid CSS selector)
        container: window, // The element to spy on scrolling in (must be a valid DOM Node) 
        offset: 250, // Distance in pixels to offset calculations
        activeClass: 'home-page-nav-active', // Class to apply to active navigation link and its parent list item
        scrollDelay: false, // Wait until scrolling has stopped before updating the navigation
        callback: function (nav) {
            addActiveClass();
        } // Callback to run after setting active link
    });
}


// WEBPACK FOOTER //
// ./Static/javascript/pages/home.ts